import axios from "axios";

const SYNC_BASE_URL = process.env.REACT_APP_SYNC_BASE_URL;
const STAR_BASE_URL = `${SYNC_BASE_URL}/api/admin/star-performers`;
const ASSESSMENT_FLOW_BASE_URL = `${SYNC_BASE_URL}/api/admin/assessment-flow`;

const APP_KEY = process.env.REACT_APP_SYNC_ADMIN_APP_KEY;

const headers = {
  "sync-app-key": APP_KEY, // change this header name if your API expects something else
};

// Get All
export const getStarPerformers = async (
  params = {}
) => {
  const response = await axios.get(
    STAR_BASE_URL,
    {
      params,
      headers,
    }
  );

  return response.data;
};

// Get By Id
export const getStarPerformerById = async (
  performerId
) => {
  const response = await axios.get(
    `${STAR_BASE_URL}/${performerId}`,
    {
      headers,
    }
  );

  return response.data;
};

//Get star peroformers by level 
export const getStarPerformerLevels =
  async (
    adminClientId,
    adminRoleId
  ) => {
    const response = await axios.get(
      `${STAR_BASE_URL}/levels`,
      {
        headers,
        params: {
          adminClientId:
            Number(adminClientId),

          adminRoleId:
            Number(adminRoleId),
        },
      }
    );

    return response.data;
  };

//Get star performers options for dropdown
export const getStarPerformerOptions =
  async () => {
    const response = await axios.get(
      `${STAR_BASE_URL}/options`,
      {
        headers,
      }
    );

    return response.data;
  };

// Create star performers for role video configuration
export const createStarPerformer = async (
  payload,
  options = {}
) => {
  const formData =
    new FormData();

  if (
    options.adminClientId !==
      undefined &&
    options.adminClientId !== null
  ) {
    formData.append(
      "adminClientId",
      String(
        Number(
          options.adminClientId
        )
      )
    );
  }

  if (
    options.adminRoleId !==
      undefined &&
    options.adminRoleId !== null
  ) {
    formData.append(
      "adminRoleId",
      String(
        Number(
          options.adminRoleId
        )
      )
    );
  }

  formData.append(
    "payload",
    JSON.stringify(payload)
  );

  if (
    options.profileImage
  ) {
    formData.append(
      "profileImage",
      options.profileImage
    );
  }

  /*
   * Never send the string "null".
   */
  if (
    options.changedBy !==
      undefined &&
    options.changedBy !== null
  ) {
    formData.append(
      "changedBy",
      String(
        Number(
          options.changedBy
        )
      )
    );
  }

  const response =
    await axios.post(
      STAR_BASE_URL,
      formData,
      {
        headers,
      }
    );

  return response.data;
};

// Update star performers for role video configuration
export const updateStarPerformer =
  async (
    performerId,
    payload,
    options = {}
  ) => {
    const formData =
      new FormData();

    /*
     * Only append payload when
     * there is actually something
     * to update.
     */
    if (
      payload &&
      Object.keys(payload).length > 0
    ) {
      formData.append(
        "payload",
        JSON.stringify(payload)
      );
    }

    if (
      options.adminClientId !==
        undefined &&
      options.adminClientId !== null
    ) {
      formData.append(
        "adminClientId",
        String(
          Number(
            options.adminClientId
          )
        )
      );
    }

    if (
      options.adminRoleId !==
        undefined &&
      options.adminRoleId !== null
    ) {
      formData.append(
        "adminRoleId",
        String(
          Number(
            options.adminRoleId
          )
        )
      );
    }

    if (
      options.profileImage
    ) {
      formData.append(
        "profileImage",
        options.profileImage
      );
    }

    /*
     * Never send:
     * changedBy = "null"
     */
    if (
      options.changedBy !==
        undefined &&
      options.changedBy !== null
    ) {
      formData.append(
        "changedBy",
        String(
          Number(
            options.changedBy
          )
        )
      );
    }

    const response =
      await axios.patch(
        `${STAR_BASE_URL}/${performerId}`,
        formData,
        {
          headers,
        }
      );

    return response.data;
  };

// Delete star performer
export const deleteStarPerformer =
  async (
    performerId,
    changedBy
  ) => {
    const params = {};

    /*
     * Only send changedBy when
     * we have a real numeric ID.
     */
    if (
      changedBy !== undefined &&
      changedBy !== null
    ) {
      params.changedBy =
        Number(changedBy);
    }

    const response =
      await axios.delete(
        `${STAR_BASE_URL}/${performerId}`,
        {
          headers,
          params,
        }
      );

    return response.data;
  };

//Get each questions by star peroformers
export const getStarPerformerQuestions =
  async (
    performerId,
    levelNumber,
    adminClientId,
    adminRoleId
  ) => {
    const response =
      await axios.get(
        `${STAR_BASE_URL}/${performerId}/levels/${levelNumber}/questions`,
        {
          headers,

          params: {
            adminClientId:
              Number(adminClientId),

            adminRoleId:
              Number(adminRoleId),
          },
        }
      );

    return response.data;
  };

//add new question for star performers
export const addStarPerformerQuestion =
  async (
    performerId,
    levelNumber,
    payload,
    options = {}
  ) => {
    const params = {
      adminClientId:
        Number(
          options.adminClientId
        ),

      adminRoleId:
        Number(
          options.adminRoleId
        ),
    };

    if (
      options.changedBy !==
        undefined &&
      options.changedBy !== null
    ) {
      params.changedBy =
        Number(
          options.changedBy
        );
    }

    const response =
      await axios.post(
        `${STAR_BASE_URL}/${performerId}/levels/${levelNumber}/questions`,
        payload,
        {
          headers,
          params,
        }
      );

    return response.data;
  };

// update star-performer question 
export const updateStarPerformerQuestion =
  async (
    performerId,
    levelNumber,
    questionId,
    payload,
    options = {}
  ) => {
    const params = {
      adminClientId:
        Number(
          options.adminClientId
        ),

      adminRoleId:
        Number(
          options.adminRoleId
        ),
    };

    if (
      options.changedBy !==
        undefined &&
      options.changedBy !== null
    ) {
      params.changedBy =
        Number(
          options.changedBy
        );
    }

    const response =
      await axios.patch(
        `${STAR_BASE_URL}/${performerId}/levels/${levelNumber}/questions/${questionId}`,
        payload,
        {
          headers,
          params,
        }
      );

    return response.data;
  };

// delete star-performer question
export const deleteStarPerformerQuestion =
  async (
    performerId,
    levelNumber,
    questionId,
    options = {}
  ) => {
    const params = {
      adminClientId:
        Number(
          options.adminClientId
        ),

      adminRoleId:
        Number(
          options.adminRoleId
        ),
    };

    if (
      options.changedBy !==
        undefined &&
      options.changedBy !== null
    ) {
      params.changedBy =
        Number(
          options.changedBy
        );
    }

    const response =
      await axios.delete(
        `${STAR_BASE_URL}/${performerId}/levels/${levelNumber}/questions/${questionId}`,
        {
          headers,
          params,
        }
      );

    return response.data;
  };


// ===================== ASSESSMENT Journy APIs =====================

export const getAssessmentFlow = async (
  adminRoleId,
  adminClientId
) => {
  const response = await axios.get(
    `${ASSESSMENT_FLOW_BASE_URL}/${adminRoleId}`,
    {
      params: {
        adminClientId,
      },
      headers,
    }
  );

  return response.data;
};

export const saveAssessmentFlow = async (
  adminRoleId,
  adminClientId,
  payload
) => {
  const response = await axios.put(
    `${ASSESSMENT_FLOW_BASE_URL}/${adminRoleId}`,
    payload,
    {
      params: {
        adminClientId,
      },
      headers,
    }
  );

  return response.data;
};

// ===================== ASSESSMENT CONFIGURATION APIs =====================

const ASSESSMENT_CONFIG_BASE_URL =
  `${SYNC_BASE_URL}/api/admin/assessment-configuration`;

/*
 * ============================================================
 * Helper
 * ============================================================
 *
 * We should never send:
 *
 * changedBy: "null"
 *
 * and we should not convert null into NaN.
 *
 * If a real numeric admin user ID exists, send it.
 * Otherwise simply omit changedBy.
 */
const appendChangedBy = (body, changedBy) => {
  if (
    changedBy !== undefined &&
    changedBy !== null &&
    Number.isFinite(Number(changedBy))
  ) {
    body.changedBy = Number(changedBy);
  }

  return body;
};


/* ============================================================
 * DEMOGRAPHIC ASSESSMENT
 * ============================================================ */


/*
 * ------------------------------------------------------------
 * GET ALL DEMOGRAPHIC QUESTIONS
 * ------------------------------------------------------------
 *
 * GET
 * /api/admin/assessment-configuration/{adminRoleId}/questions
 *
 * Query:
 *   adminClientId
 *   type=demographic
 *   page
 *   limit
 *   search
 */
export const getDemographicQuestions = async (
  adminRoleId,
  adminClientId,
  params = {}
) => {
  if (!adminRoleId) {
    throw new Error(
      "adminRoleId is required."
    );
  }

  if (!adminClientId) {
    throw new Error(
      "adminClientId is required."
    );
  }

  const queryParams = {
    adminClientId:
      Number(adminClientId),

    search:
      params.search ?? "",

    page:
      params.page ?? 1,

    limit:
      params.limit ?? 10,
  };

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/questions`,
    {
      headers,
      params: queryParams,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * GET ONE DEMOGRAPHIC QUESTION
 * ------------------------------------------------------------
 *
 * GET
 * /{adminRoleId}/questions/{questionId}
 *
 * Query:
 *   adminClientId
 *   type=demographic
 */
export const getDemographicQuestionById = async (
  adminRoleId,
  questionId,
  adminClientId
) => {
  if (!adminRoleId) {
    throw new Error(
      "adminRoleId is required."
    );
  }

  if (!questionId) {
    throw new Error(
      "questionId is required."
    );
  }

  if (!adminClientId) {
    throw new Error(
      "adminClientId is required."
    );
  }

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/questions/${questionId}`,
    {
      headers,

      params: {
        adminClientId:
          Number(adminClientId),
      },
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * CREATE DEMOGRAPHIC QUESTION
 * ------------------------------------------------------------
 *
 * POST
 * /{adminRoleId}/questions
 *
 * Body:
 *
 * {
 *   adminClientId,
 *   type: "demographic",
 *   payload: {...},
 *   changedBy
 * }
 */
export const createDemographicQuestion = async (
  adminRoleId,
  payload,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error(
      "adminRoleId is required."
    );
  }

  if (!options.adminClientId) {
    throw new Error(
      "adminClientId is required."
    );
  }

  const body = {
    adminClientId:
      Number(options.adminClientId),
    type: "demographic",
    payload,
  };

  /*
   * changedBy is optional.
   *
   * Do NOT send "null" as a string.
   * If there is no valid admin user ID,
   * simply don't include it.
   */
  if (
    options.changedBy !== undefined &&
    options.changedBy !== null &&
    Number.isFinite(
      Number(options.changedBy)
    )
  ) {
    body.changedBy =
      Number(options.changedBy);
  }

  const response = await axios.post(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/questions`,
    body,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * UPDATE DEMOGRAPHIC QUESTION
 * ------------------------------------------------------------
 *
 * PATCH
 * /{adminRoleId}/questions/{questionId}
 *
 * Body:
 *
 * {
 *   adminClientId,
 *   type: "demographic",
 *   payload: {...},
 *   changedBy
 * }
 */
export const updateDemographicQuestion = async (
  adminRoleId,
  questionId,
  payload,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error(
      "adminRoleId is required."
    );
  }

  if (!questionId) {
    throw new Error(
      "questionId is required."
    );
  }

  if (!options.adminClientId) {
    throw new Error(
      "adminClientId is required."
    );
  }

  const body = {
    adminClientId:
      Number(options.adminClientId),
    type: "demographic",
    payload,
  };

  if (
    options.changedBy !== undefined &&
    options.changedBy !== null &&
    Number.isFinite(
      Number(options.changedBy)
    )
  ) {
    body.changedBy =
      Number(options.changedBy);
  }

  const response = await axios.patch(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/questions/${questionId}`,
    body,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * DELETE DEMOGRAPHIC QUESTION
 * ------------------------------------------------------------
 *
 * DELETE
 * /{adminRoleId}/questions/{questionId}
 *
 * Query:
 *   adminClientId
 *   type=demographic
 *   changedBy
 *
 * The backend performs a soft delete.
 */
export const deleteDemographicQuestion = async (
  adminRoleId,
  questionId,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error(
      "adminRoleId is required."
    );
  }

  if (!questionId) {
    throw new Error(
      "questionId is required."
    );
  }

  if (!options.adminClientId) {
    throw new Error(
      "adminClientId is required."
    );
  }

  const params = {
    adminClientId:
      Number(options.adminClientId),
  };

  if (
    options.changedBy !== undefined &&
    options.changedBy !== null &&
    Number.isFinite(
      Number(options.changedBy)
    )
  ) {
    params.changedBy =
      Number(options.changedBy);
  }

  const response = await axios.delete(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/questions/${questionId}`,
    {
      headers,
      params,
    }
  );

  return response.data;
};


/* ============================================================
 * SCENARIO ASSESSMENT
 * ============================================================ */


/*
 * ------------------------------------------------------------
 * GET ALL SCENARIOS
 * ------------------------------------------------------------
 *
 * GET
 * /{adminRoleId}/scenarios
 *
 * Query:
 *   adminClientId
 *   page
 *   limit
 *   search
 */
export const getScenarios = async (
  adminRoleId,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  const params = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : undefined,

    page:
      options.page !== undefined
        ? Number(options.page)
        : 1,

    limit:
      options.limit !== undefined
        ? Number(options.limit)
        : 10,

    search:
      options.search?.trim() || undefined,
  };

  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios`,
    {
      headers,
      params: cleanedParams,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * GET ONE SCENARIO
 * ------------------------------------------------------------
 *
 * GET
 * /{adminRoleId}/scenarios/{scenarioId}
 *
 * Query:
 *   adminClientId
 */
export const getScenarioById = async (
  adminRoleId,
  scenarioId,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  const params = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : undefined,
  };

  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}`,
    {
      headers,
      params: cleanedParams,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * CREATE SCENARIO
 * ------------------------------------------------------------
 *
 * POST
 * /{adminRoleId}/scenarios
 *
 * Body:
 *
 * {
 *   adminClientId,
 *   payload: {
 *     scenarioTypeId,
 *     video: {...},
 *     isActive
 *   },
 *   changedBy
 * }
 */
export const createScenario = async (
  adminRoleId,
  payload,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!payload) {
    throw new Error("Scenario payload is required.");
  }

  const body = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : null,

    payload,
  };

  appendChangedBy(
    body,
    options.changedBy
  );

  const response = await axios.post(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios`,
    body,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * UPDATE SCENARIO
 * ------------------------------------------------------------
 *
 * PATCH
 * /{adminRoleId}/scenarios/{scenarioId}
 *
 * Body:
 *
 * {
 *   adminClientId,
 *   payload: {...},
 *   changedBy
 * }
 */
export const updateScenario = async (
  adminRoleId,
  scenarioId,
  payload,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  if (!payload) {
    throw new Error("Scenario payload is required.");
  }

  const body = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : null,

    payload,
  };

  appendChangedBy(
    body,
    options.changedBy
  );

  const response = await axios.patch(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}`,
    body,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * DELETE SCENARIO
 * ------------------------------------------------------------
 *
 * DELETE
 * /{adminRoleId}/scenarios/{scenarioId}
 *
 * Query:
 *   adminClientId
 *   changedBy
 */
export const deleteScenario = async (
  adminRoleId,
  scenarioId,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  const params = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : undefined,

    changedBy:
      options.changedBy !== undefined &&
      options.changedBy !== null &&
      Number.isFinite(Number(options.changedBy))
        ? Number(options.changedBy)
        : undefined,
  };

  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );

  const response = await axios.delete(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}`,
    {
      headers,
      params: cleanedParams,
    }
  );

  return response.data;
};


/* ============================================================
 * SCENARIO QUESTIONS
 * ============================================================ */


/*
 * ------------------------------------------------------------
 * GET ALL QUESTIONS FOR ONE SCENARIO
 * ------------------------------------------------------------
 *
 * GET
 * /{adminRoleId}/scenarios/{scenarioId}/questions
 *
 * Query:
 *   adminClientId
 *   page
 *   limit
 *   search
 */
export const getScenarioQuestions = async (
  adminRoleId,
  scenarioId,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  const params = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : undefined,

    page:
      options.page !== undefined
        ? Number(options.page)
        : 1,

    limit:
      options.limit !== undefined
        ? Number(options.limit)
        : 10,

    search:
      options.search?.trim() || undefined,
  };

  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}/questions`,
    {
      headers,
      params: cleanedParams,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * GET ONE SCENARIO QUESTION
 * ------------------------------------------------------------
 *
 * GET
 * /{adminRoleId}/scenarios/{scenarioId}/questions/{questionId}
 */
export const getScenarioQuestionById = async (
  adminRoleId,
  scenarioId,
  questionId,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  if (!questionId) {
    throw new Error("Question ID is required.");
  }

  const params = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : undefined,
  };

  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}/questions/${questionId}`,
    {
      headers,
      params: cleanedParams,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * CREATE SCENARIO QUESTION
 * ------------------------------------------------------------
 *
 * POST
 * /{adminRoleId}/scenarios/{scenarioId}/questions
 *
 * Body:
 *
 * {
 *   adminClientId,
 *   payload: {
 *     title,
 *     description,
 *     questionTypeId,
 *     options,
 *     weightage,
 *     isActive
 *   },
 *   changedBy
 * }
 */
export const createScenarioQuestion = async (
  adminRoleId,
  scenarioId,
  payload,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  if (!payload) {
    throw new Error("Question payload is required.");
  }

  const body = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : null,

    payload,
  };

  appendChangedBy(
    body,
    options.changedBy
  );

  const response = await axios.post(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}/questions`,
    body,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * UPDATE SCENARIO QUESTION
 * ------------------------------------------------------------
 *
 * PATCH
 * /{adminRoleId}/scenarios/{scenarioId}/questions/{questionId}
 */
export const updateScenarioQuestion = async (
  adminRoleId,
  scenarioId,
  questionId,
  payload,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  if (!questionId) {
    throw new Error("Question ID is required.");
  }

  if (!payload) {
    throw new Error("Question payload is required.");
  }

  const body = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : null,

    payload,
  };

  appendChangedBy(
    body,
    options.changedBy
  );

  const response = await axios.patch(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}/questions/${questionId}`,
    body,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * DELETE SCENARIO QUESTION
 * ------------------------------------------------------------
 *
 * DELETE
 * /{adminRoleId}/scenarios/{scenarioId}/questions/{questionId}
 *
 * Query:
 *   adminClientId
 *   changedBy
 */
export const deleteScenarioQuestion = async (
  adminRoleId,
  scenarioId,
  questionId,
  options = {}
) => {
  if (!adminRoleId) {
    throw new Error("Admin role ID is required.");
  }

  if (!scenarioId) {
    throw new Error("Scenario ID is required.");
  }

  if (!questionId) {
    throw new Error("Question ID is required.");
  }

  const params = {
    adminClientId:
      options.adminClientId !== undefined &&
      options.adminClientId !== null
        ? Number(options.adminClientId)
        : undefined,

    changedBy:
      options.changedBy !== undefined &&
      options.changedBy !== null &&
      Number.isFinite(Number(options.changedBy))
        ? Number(options.changedBy)
        : undefined,
  };

  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );

  const response = await axios.delete(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/${scenarioId}/questions/${questionId}`,
    {
      headers,
      params: cleanedParams,
    }
  );

  return response.data;
};


/* ============================================================
 * ASSESSMENT OPTIONS
 * ============================================================ */


/*
 * GET:
 * /api/admin/assessment-configuration/options
 *
 * Returns:
 *   assessmentTypes
 *   questionTypes
 *   scenarioTypes
 */
export const getAssessmentConfigurationOptions = async (
  adminRoleId,
  adminClientId
) => {
  if (!adminRoleId) {
    throw new Error(
      "adminRoleId is required."
    );
  }

  if (!adminClientId) {
    throw new Error(
      "adminClientId is required."
    );
  }

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/options`,
    {
      headers,

      params: {
        adminClientId:
          Number(adminClientId),
      },
    }
  );

  return response.data;
};


/*
 * GET:
 * /api/admin/assessment-configuration/scenario-options
 *
 * Returns:
 *   scenarioTypes
 *   videoLanguages
 *   questionTypes
 */
export const getScenarioConfigurationOptions = async (
    adminRoleId,
    options = {}
  ) => {
    if (!adminRoleId) {
      throw new Error("adminRoleId is required.");
    }

    if (!options.adminClientId) {
      throw new Error("adminClientId is required.");
    }

    const response = await axios.get(
      `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/scenarios/options`,
      {
        headers,
        params: {
          adminClientId: Number(
            options.adminClientId
          ),
        },
      }
    );

    return response.data;
  };

// ===================== ROLE DETAILS CONFIGURATION APIs =====================

const ROLE_DETAILS_BASE_URL = `${SYNC_BASE_URL}/api/admin/role-details`;

/*
 * ============================================================
 * HELPER
 * Convert payload to FormData for POST/PATCH APIs.
 *
 * The SYNC Role Details API expects multipart/form-data.
 * ============================================================
 */

const buildRoleDetailsFormData = (payload = {}) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    /*
     * Arrays such as locations need to be sent as JSON.
     */
    if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    /*
     * File objects can be appended directly.
     */
    if (value instanceof File) {
      formData.append(key, value);
      return;
    }

    formData.append(key, String(value));
  });

  return formData;
};


/*
 * ============================================================
 * GET ROLE + CLIENT DETAILS
 *
 * GET
 * /api/admin/role-details/getRoleDetails
 *
 * Query:
 * adminClientId
 * adminRoleId
 *
 * Used to initialize Add Job page.
 * ============================================================
 */

export const getRoleAndClientDetails = async ({
  adminClientId,
  adminRoleId,
} = {}) => {
  const params = {};

  if (
    adminClientId !== undefined &&
    adminClientId !== null
  ) {
    params.adminClientId = Number(adminClientId);
  }

  if (
    adminRoleId !== undefined &&
    adminRoleId !== null
  ) {
    params.adminRoleId = Number(adminRoleId);
  }

  const response = await axios.get(
    `${ROLE_DETAILS_BASE_URL}/getRoleDetails`,
    {
      headers,
      params,
    }
  );

  return response.data;
};


/*
 * ============================================================
 * GET ROLE DETAILS OPTIONS
 *
 * GET
 * /api/admin/role-details/options
 *
 * Returns:
 * employmentTypes
 * workModes
 * locations
 * educationTypes
 * ============================================================
 */

export const getRoleDetailOptions = async () => {
  const response = await axios.get(
    `${ROLE_DETAILS_BASE_URL}/options`,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ============================================================
 * GET SEARCHABLE LOCATIONS
 *
 * GET
 * /api/admin/role-details/locations?search={search}
 * ============================================================
 */

export const getRoleDetailLocations = async (
  search = ""
) => {
  const params = {};

  if (search?.trim()) {
    params.search = search.trim();
  }

  const response = await axios.get(
    `${ROLE_DETAILS_BASE_URL}/locations`,
    {
      headers,
      params,
    }
  );

  return response.data;
};


/*
 * ============================================================
 * CREATE JOB / DESIGNATION
 *
 * POST
 * /api/admin/role-details
 *
 * multipart/form-data
 *
 * options:
 * adminClientId
 * changedBy
 * ============================================================
 */

export const createRoleDetail = async (
  payload,
  options = {},
  jobLogoFile = null
) => {
  const formData = new FormData();

  /*
   * Admin Client
   */
  if (
    options.adminClientId !== undefined &&
    options.adminClientId !== null
  ) {
    formData.append(
      "adminClientId",
      String(Number(options.adminClientId))
    );
  }

  /*
   * Admin Role
   */
  if (
    options.adminRoleId !== undefined &&
    options.adminRoleId !== null
  ) {
    formData.append(
      "adminRoleId",
      String(Number(options.adminRoleId))
    );
  }

  /*
   * Root Admin
   */
  if (
    options.changedBy !== undefined &&
    options.changedBy !== null
  ) {
    formData.append(
      "changedBy",
      String(Number(options.changedBy))
    );
  }

  /*
   * IMPORTANT:
   * Backend expects the actual job data
   * inside a "payload" field.
   */
  formData.append(
    "payload",
    JSON.stringify(payload)
  );

  /*
   * Job Logo
   *
   * The actual File object is sent separately
   * from the JSON payload.
   */
  if (jobLogoFile instanceof File) {
    formData.append(
      "jobLogo",
      jobLogoFile
    );
  }

  const response = await axios.post(
    ROLE_DETAILS_BASE_URL,
    formData,
    {
      headers: {
        ...headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};


/*
 * ============================================================
 * GET ALL JOBS UNDER ROLE
 *
 * GET
 * /api/admin/role-details
 *
 * Query:
 * adminClientId
 * adminRoleId
 * page
 * pageSize
 * ============================================================
 */

export const getRoleDetailsList = async ({
  adminClientId,
  adminRoleId,
  page = 1,
  pageSize = 10,
} = {}) => {
  const params = {
    page,
    pageSize,
  };

  if (
    adminClientId !== undefined &&
    adminClientId !== null
  ) {
    params.adminClientId =
      Number(adminClientId);
  }

  if (
    adminRoleId !== undefined &&
    adminRoleId !== null
  ) {
    params.adminRoleId =
      Number(adminRoleId);
  }

  const response = await axios.get(
    ROLE_DETAILS_BASE_URL,
    {
      headers,
      params,
    }
  );

  return response.data;
};


/*
 * ============================================================
 * GET ONE JOB / DESIGNATION
 *
 * GET
 * /api/admin/role-details/{id}
 *
 * id = SYNC Job/Role Detail Mongo ID
 * ============================================================
 */

export const getRoleDetailById = async (
  id
) => {
  if (!id) {
    throw new Error(
      "Role detail ID is required."
    );
  }

  const response = await axios.get(
    `${ROLE_DETAILS_BASE_URL}/${id}`,
    {
      headers,
    }
  );

  return response.data;
};


/*
 * ============================================================
 * UPDATE JOB / DESIGNATION
 *
 * PATCH
 * /api/admin/role-details/{id}
 *
 * multipart/form-data
 *
 * options:
 * adminClientId
 * changedBy
 * ============================================================
 */

export const updateRoleDetail = async (
  id,
  payload,
  options = {},
  jobLogoFile = null
) => {
  if (!id) {
    throw new Error("Role detail ID is required.");
  }

  const formData = new FormData();

  /*
   * Backend PATCH route expects the actual
   * update fields inside a JSON "payload" field.
   *
   * Example:
   * {
   *   salaryMax: 20000
   * }
   *
   * becomes:
   *
   * payload = '{"salaryMax":20000}'
   */
  formData.append(
    "payload",
    JSON.stringify(payload)
  );

  if (
    options.adminClientId !== undefined &&
    options.adminClientId !== null
  ) {
    formData.append(
      "adminClientId",
      String(Number(options.adminClientId))
    );
  }

  if (
    options.adminRoleId !== undefined &&
    options.adminRoleId !== null
  ) {
    formData.append(
      "adminRoleId",
      String(Number(options.adminRoleId))
    );
  }

  if (
    options.changedBy !== undefined &&
    options.changedBy !== null
  ) {
    formData.append(
      "changedBy",
      String(Number(options.changedBy))
    );
  }

  /*
   * Job Logo
   *
   * The actual File object is sent separately
   * from the JSON payload.
   */
  if (jobLogoFile instanceof File) {
    formData.append(
      "jobLogo",
      jobLogoFile
    );
  }

  const response = await axios.patch(
    `${ROLE_DETAILS_BASE_URL}/${id}`,
    formData,
    {
      headers: {
        ...headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};


/*
 * ============================================================
 * DELETE JOB / DESIGNATION
 *
 * DELETE
 * /api/admin/role-details/{id}
 *
 * changedBy must be the logged-in admin ID.
 * ============================================================
 */

export const deleteRoleDetail = async (
  id,
  options = {}
) => {
  if (!id) {
    throw new Error(
      "Role detail ID is required."
    );
  }

  const data = {};

  if (
    options.adminClientId !== undefined &&
    options.adminClientId !== null
  ) {
    data.adminClientId =
      Number(options.adminClientId);
  }

  if (
    options.changedBy !== undefined &&
    options.changedBy !== null
  ) {
    data.changedBy =
      Number(options.changedBy);
  }

  const response = await axios.delete(
    `${ROLE_DETAILS_BASE_URL}/${id}`,
    {
      headers,
      data,
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * GET JP FITMENT CONFIGURATION
 * ------------------------------------------------------------
 *
 * GET
 * /{adminRoleId}/jpFitment
 *
 * Query:
 *   adminClientId
 */
export const getJPFitmentConfiguration = async (
  adminRoleId,
  adminClientId
) => {
  if (!adminRoleId) {
    throw new Error("adminRoleId is required.");
  }

  if (!adminClientId) {
    throw new Error("adminClientId is required.");
  }

  const response = await axios.get(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/jpFitment`,
    {
      headers,
      params: {
        adminClientId: Number(adminClientId),
      },
    }
  );

  return response.data;
};


/*
 * ------------------------------------------------------------
 * UPDATE JP FITMENT CONFIGURATION
 * ------------------------------------------------------------
 *
 * PATCH
 * /{adminRoleId}/jpFitment
 *
 * Query:
 *   adminClientId
 *
 * Body:
 *   primaryTraitScore
 *   secondaryTraitScore
 *   supportingTraitScore
 *   categories
 */
export const updateJPFitmentConfiguration = async (
  adminRoleId,
  adminClientId,
  payload
) => {
  if (!adminRoleId) {
    throw new Error("adminRoleId is required.");
  }

  if (!adminClientId) {
    throw new Error("adminClientId is required.");
  }

  if (!payload) {
    throw new Error(
      "JP Fitment configuration payload is required."
    );
  }

  const response = await axios.patch(
    `${ASSESSMENT_CONFIG_BASE_URL}/${adminRoleId}/jpFitment`,
    payload,
    {
      headers,
      params: {
        adminClientId: Number(adminClientId),
      },
    }
  );

  return response.data;
};